import type { Maybe } from '../../codegen/types';

export const transformStringToNumber = (value: Maybe<string> | string | undefined) => {
  if (typeof value === 'number') return value;
  if (!value) return NaN;
  return parseFloat(value.match?.(/-?\d+(\.\d+)?/g)?.[0] || '');
};
